import { render, staticRenderFns } from "./CollapseTypes.vue?vue&type=template&id=f9b10fda"
import script from "./CollapseTypes.vue?vue&type=script&lang=js"
export * from "./CollapseTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports